import { GlAlert, GlLink, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'WikiAlert',
    components: {
        GlAlert,
        GlLink,
        GlSprintf
    },
    props: {
        error: {
            type: String,
            required: true
        },
        wikiPagePath: {
            type: String,
            required: true
        }
    }
};
